import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Star } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 min-h-[90vh] flex items-center overflow-hidden" data-id="element-87">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full" data-id="element-88">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-8 items-stretch" data-id="element-89">
          {/* Left Content */}
          <motion.div className="lg:col-span-3 flex flex-col gap-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-90">
            <h1 className="font-display text-5xl lg:text-6xl xl:text-7xl leading-[1.05] text-brand-charcoal text-balance max-w-[14ch]" data-id="element-91">
              Bienestar Mental y Salud Integral Basados en Ciencia
            </h1>

            <p className="leading-relaxed border-0 outline-none" style={{
            color: '#6B7280',
            fontSize: '18px',
            maxWidth: '520px'
          }} data-id="element-92">
              Descifra el código de tu bienestar. Guías digitales que convierten
              la ciencia de la salud en hábitos simples, naturales y
              transformadores para toda tu familia.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-93">
              <a href="#productos" className="inline-flex items-center justify-center bg-brand-emerald text-white px-8 py-4 rounded-lg font-medium text-lg hover:bg-emerald-900 hover:scale-[1.02] transition-all duration-200 shadow-lg shadow-brand-emerald/20" data-id="element-94">
                Ver todos los productos &rarr;
              </a>
              <a href="#nosotros" className="inline-flex items-center justify-center border-2 border-brand-emerald text-brand-emerald px-8 py-4 rounded-lg font-medium text-lg hover:bg-brand-emerald/5 transition-all duration-200" data-id="element-95">
                ¿Quiénes somos?
              </a>
            </div>

            <div className="flex flex-wrap gap-6 pt-6 border-t border-gray-200/60 mt-2" data-id="element-96">
              <div className="flex items-center gap-2 text-sm font-medium text-brand-charcoal" data-id="element-97">
                <CheckCircle2 className="w-5 h-5 text-brand-emerald" data-id="element-98" />
                <span data-id="element-99">Basado en ciencia</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-medium text-brand-charcoal" data-id="element-100">
                <Download className="w-5 h-5 text-brand-emerald" data-id="element-101" />
                <span data-id="element-102">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-medium text-brand-charcoal" data-id="element-103">
                <Star className="w-5 h-5 text-brand-emerald fill-brand-emerald" data-id="element-104" />
                <span data-id="element-105">+500 personas transformadas</span>
              </div>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div className="lg:col-span-2 relative flex" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-106">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brand-emerald/10 aspect-[9/16] w-full max-w-sm mx-auto lg:max-w-none lg:mx-0 lg:h-full lg:aspect-auto" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/c5kev4EZYYgsNpzbhxQbYQ/ChatGPT_Image_20_may_2026,_12_00_47_a.m..png" alt="Familia feliz y saludable caminando en la naturaleza al atardecer" className="absolute inset-0 w-full h-full object-cover object-center block" data-id="element-108" />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-black/10 pointer-events-none" data-id="element-109"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-brand-mint/30 rounded-full blur-2xl -z-10" data-id="element-110"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-brand-salmon/20 rounded-full blur-2xl -z-10" data-id="element-111"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}